export default __webpack_public_path__ + "a279244914e45f881343ab1a7fc59759.webp";